import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { useNavigate, useLocation } from 'react-router';
import styles from './HomeFooter.module.css';
import gameAssets from '@themed-assets';
import { messageToNativeClient } from '../../../Common/utils/platformCommunicationUtil';
import usePlayerDetails from '@/src/hooks/data/usePlayerDetails';

const HomeFooter = ({ isVisible }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userName } = usePlayerDetails();

  const tabItems = [
    {
      icon: gameAssets.footerHome,
      label: "Home",
      path: "/",
      id: "footer-home-icon"
    },
    {
      icon: gameAssets.footerCash,
      label: "Games",
      path: "/cashLobby",
      id: "footer-cash-games-icon"
    },
    {
      icon: gameAssets.footerTourney,
      label: "Tourneys",
      path: "/tourneyLobby",
      id: "footer-tourney-games-icon"
    },
    {
      icon: gameAssets.playerAvatar,
      label: userName,
      // path: "/cashier",
      id: "footer-profile-icon"
    }
  ];

  const handleNavigation = (path, label) => {
    if (!path) {
      messageToNativeClient({ type: "openSideDrawer", isOpened: true });
    } else {
      navigate(path);
    }
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.footer
          className={styles.homeFooter}
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
        >
          <motion.div
            className={styles.footerTabs}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {tabItems.map((item, index) => (
              <motion.div
                key={item.label}
                id={item.id}
                onClick={() => handleNavigation(item.path, item.label)}
                className={`${styles.footerTab} ${location.pathname === item.path ? styles.active : ''}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  delay: index * 0.05,
                  type: "spring",
                  stiffness: 400
                }}
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                <img src={item.icon} className={styles.tabIcon}></img>
                <span className={styles.tabLabel}>{item.label}</span>
              </motion.div>
            ))}
          </motion.div>
        </motion.footer>
      )}
    </AnimatePresence>
  );
};

export default HomeFooter; 